import { IDepartment, IEmployee } from '@api'
import { Position, Tab, Tabs } from '@blueprintjs/core'
import { Button, DepartmentCatalog, Popover } from '@ui'
import EmployeeCatalog from 'components/EmployeeCatalog'
import { useState } from 'react'
import React from 'react'

export default function EmployeeAndDepartmentList({
  onSelectEmployee,
  onSelectDepartment,
}: {
  onSelectEmployee: (item: IEmployee | null) => void
  onSelectDepartment: (item: IDepartment | null) => void
}) {
  const [tabId, setTabId] = useState('1')
  return (
    <Popover
      minimal
      position={Position.BOTTOM_RIGHT}
      content={
        <div className="bp4-tabs-override">
          <Tabs
            selectedTabId={tabId}
            onChange={(newTabId: string) => setTabId(newTabId)}
            renderActiveTabPanelOnly>
            <Tab
              id="1"
              title="Employee"
              panel={
                <div style={{ height: 290 }}>
                  <EmployeeCatalog onSelect={onSelectEmployee} height={'100%'} />
                </div>
              }
            />
            <Tab
              id="2"
              title="Department"
              panel={
                <div style={{ height: 290 }}>
                  <DepartmentCatalog onSelect={onSelectDepartment} />
                </div>
              }
            />
          </Tabs>
        </div>
      }>
      <Button iconName="plus" text="Employee/Department" />
    </Popover>
  )
}
